import React, { Component } from 'react'

export default class text extends Component {
    render() {

        return (
            <div style={{ zIndex: '1' }}>

                <h1 style={{ textAlign: 'center', paddingTop: '30px', letterSpacing: '-1px', fontSize: '25px', color: 'black', width: '100%', marginBottom: '-30px', marginLeft: '5px', marginRight: '5px' }}>¿Como funciona LibérameApp?</h1>
                <p style={{ textAlign: 'center', paddingTop: '20px', textdecoration: 'underline', letterSpacing: '-1px', fontSize: '18px', color: 'black', width: '100%', marginBottom: '-50px', marginLeft: '5px', marginRight: '5px' }}>Complete un formulario rápido para ayudarnos a comprender sus objetivos, presupuesto y preferencias personales.</p>




            </div>

        )
    }
}
